import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectFilterByTypeModal = createSelector(
  [(store: RootState) => store.documentsSignerList.showFilterByTypeModal],
  (type) => type
);
